import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Lazy-load brochure iframe when you scroll to that section.
 */
const brochureIframe = document.querySelector('#brochure iframe');
if (brochureIframe) {
  ScrollTrigger.create({
    trigger: '#brochure',
    top: '-=100vh',
    onEnter() {
      if (!brochureIframe.hasAttribute('src')) {
        brochureIframe.setAttribute('src', brochureIframe.getAttribute('data-src'));
      }
    },
  });
}
